import { CheckCircle2, CircleDashed, Hand, HelpCircle } from "lucide-react";

const STATUS = {
  delivered: { label: "Isporučeno", cls: "text-ok border-ok/30 bg-ok/10", Icon: CheckCircle2 },
  action_required: { label: "Čeka vašu radnju", cls: "text-warn border-warn/30 bg-warn/10", Icon: Hand },
  open_questions: { label: "Otvorena pitanja", cls: "text-primary border-primary/30 bg-primary/10", Icon: HelpCircle },
  deferred: { label: "Odgođeno · G4", cls: "text-muted-foreground border-border bg-elevated", Icon: CircleDashed },
};

export const StatusChip = ({ status, testId }) => {
  const s = STATUS[status] || STATUS.delivered;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-wider ${s.cls}`}
    >
      <s.Icon className="h-3 w-3" />
      {s.label}
    </span>
  );
};

export const Tag = ({ children, testId }) => (
  <span
    data-testid={testId}
    className="inline-flex items-center rounded border border-border bg-elevated px-2 py-0.5 font-mono text-[11px] text-muted-foreground"
  >
    {children}
  </span>
);
